import { trackingActions } from './actions-const';

export function userIsOnJuke() {
  return {
    type: trackingActions.USER_ON_JUKE,
  };
}

export function userLeftJuke() {
  return {
    type: trackingActions.USER_NOT_ON_JUKE,
  };
}
